import { cmsCLient } from '@/services/axiosConfig'
import { GetSDGPageRes } from './types'

export type GetSDGPageData = () => Promise<GetSDGPageRes>

export const getSDGPageData: GetSDGPageData = async () => {
  try {
    const response = await cmsCLient.get('/sdg-page')
    return response.data
  } catch (e: any) {
    return e.message
  }
}
